export enum RubricDirectionType {
    DIFFERENTIATED = 1,
    BI_DIRECTIONAL = 26,
    ONE_DIRECTIONAL = 25
}